import React from 'react';
import './TuningModalShell.css';

export type TuningModalSize = 'default' | 'eval' | 'result' | 'wide';
export type TuningModalVariant = 'config' | 'fine-tuning' | 'eval';

export interface TuningModalShellProps {
  onClose: () => void;
  title: string;
  subtitle?: string;
  iconClassName: string;
  children: React.ReactNode;
  footer: React.ReactNode;
  size?: TuningModalSize;
  variant?: TuningModalVariant;
  bodyRef?: React.Ref<HTMLDivElement>;
  zIndex?: number;
}

const TuningModalShell: React.FC<TuningModalShellProps> = ({
  onClose,
  title,
  subtitle,
  iconClassName,
  children,
  footer,
  size = 'default',
  variant = 'config',
  bodyRef,
  zIndex = 1000,
}) => {
  const panelSizeClass =
    size === 'wide'
      ? 'tuning-modal__panel--wide'
      : size === 'result'
        ? 'tuning-modal__panel--result'
        : size === 'eval'
          ? 'tuning-modal__panel--eval'
          : '';

  const panelClass = ['tuning-modal__panel', panelSizeClass, `tuning-modal__panel--${variant}`]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={`connector-form-modal tuning-modal tuning-modal--${variant}`}
      style={{ zIndex }}
    >
      <div className={panelClass} role="dialog" aria-modal="true">
        <header className="tuning-modal__header">
          <div className="tuning-modal__heading">
            <h3 className="tuning-modal__title-row">
              <span className="tuning-modal__icon" aria-hidden>
                <i className={iconClassName} />
              </span>
              {title}
            </h3>
            {subtitle ? <p className="tuning-modal__subtitle">{subtitle}</p> : null}
          </div>
          <button type="button" className="tuning-modal__close" aria-label="Close" onClick={onClose}>
            ×
          </button>
        </header>

        <div className="tuning-modal__body" ref={bodyRef}>
          {children}
        </div>

        <footer className="tuning-modal__footer">{footer}</footer>
      </div>
    </div>
  );
};

export default TuningModalShell;
